module.exports = __webpack_public_path__ + "media/img/decorations/decoration-left-img-88e184dc11609eca62e90868e1a09d47.svg";